var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUgly1Color = function SvgUgly1Color(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32780_38396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#F39677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5006C35 27.1693 27.1633 35.0006 17.5 35.0006C11.9984 35.0006 7.08748 32.4631 3.87732 28.4873C6.87966 30.9154 10.7023 32.3646 14.864 32.3646C24.5273 32.3646 32.364 24.5334 32.364 14.8646C32.364 10.7029 30.9148 6.88027 28.4867 3.87793C32.457 7.08809 35 11.999 35 17.5006Z",
    fill: "#EE6F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2801 13.4682C14.2801 15.6251 12.9491 17.3805 11.2986 17.3805C9.6492 17.3805 8.31702 15.6251 8.31702 13.4682C8.31702 11.3113 9.64811 9.56787 11.2986 9.56787C12.948 9.56787 14.2801 11.3113 14.2801 13.4682Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0397 12.3736C12.7969 12.5278 12.3922 12.3572 12.1614 11.97C11.9306 11.5938 11.9612 11.1705 12.215 11.0174C12.4578 10.862 12.8505 11.0447 13.0703 11.4199C13.3131 11.7961 13.2945 12.2194 13.0397 12.3736Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6831 13.4682C26.6831 15.6251 25.352 17.3805 23.7015 17.3805C22.0522 17.3805 20.72 15.6251 20.72 13.4682C20.72 11.3113 22.0511 9.56787 23.7015 9.56787C25.3509 9.56787 26.6831 11.3113 26.6831 13.4682Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.444 12.3736C25.2012 12.5278 24.7965 12.3572 24.5657 11.97C24.3349 11.5938 24.3645 11.1705 24.6193 11.0174C24.8621 10.862 25.2548 11.0447 25.4746 11.4199C25.7163 11.7961 25.6977 12.2194 25.444 12.3736Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2222 28.3963C26.1338 27.5659 24.1964 26.0203 21.2283 25.1801C18.8458 24.4574 15.7743 24.5183 13.6007 25.1812C10.7784 25.9811 8.9314 27.3885 7.60571 28.3953C8.68869 26.6854 10.7752 24.9352 13.2285 24.0416C16.0442 23.0163 18.9688 23.0838 21.5995 24.0427C24.0625 24.9439 26.1403 26.693 27.2222 28.3963Z",
    fill: "#3E4347"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32780_38396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUgly1Color, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ugly1Color.ba2f2102.svg";
export { ForwardRef as ReactComponent };